export default "__VITE_ASSET__f271ad3a__"